import { useEffect } from "react";
import OneTrust from "shared/util/oneTrust";

const PINGDOM_SDK_URL = "https://rum-static.pingdom.net/pa-5d2f3e8f14cfaa0008000159.js";

function usePingdom() {
	useEffect(() => {
		OneTrust.loadScript(PINGDOM_SDK_URL, OneTrust.CATEGORY.PERFORMANCE);
	}, []);
}

export default usePingdom;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/usePingdom.js